<app-pan-card class="mt-3" [header]="branch().name" [isPageContainer]="true" pageContainerSize="xl">
  @let locationData = locations();

  @if (isLoading() || !locationData) {
    <div class="flex justify-center">
      <app-pan-spinner size="xl"></app-pan-spinner>
    </div>
  } @else {
    @if (locationData.length === 0) {
      <div class="text-center mx-3">There have been no incident reports recorded for the specified time range.</div>
    } @else {
      <div class="flex gap-2 mb-3 justify-center">
        <app-pan-stat-card
          class="flex-1"
          stat="Locations with Incidents"
          [value]="theftsFound()"
          icon="visibility"
          color="danger"
        ></app-pan-stat-card>
        <app-pan-stat-card
          class="flex-1"
          stat="Locations without Incidents"
          [value]="noTheftsFound()"
          icon="visibility_off"
          color="success"
        ></app-pan-stat-card>
      </div>

      <ag-grid-angular
        data-testid="report-portal-table"
        [rowData]="tableLocations()"
        [columnDefs]="columnDefs"
        [gridOptions]="tableDef"
      ></ag-grid-angular>
    }
  }
</app-pan-card>
